// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: iPuZhFXV3wGG
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import TopBar from "../../TopBar"; // plasmic-import: 0Oim0KTDv11d/component
import ContractsListCard from "../../ContractsListCard"; // plasmic-import: japjhC-77smV/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicContractsList2.module.css"; // plasmic-import: iPuZhFXV3wGG/css

createPlasmicElementProxy;

export const PlasmicContractsList2__VariantProps = new Array();

export const PlasmicContractsList2__ArgProps = new Array();

const $$ = {};

function PlasmicContractsList2__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div
            data-plasmic-name={"freeBox"}
            data-plasmic-override={overrides.freeBox}
            className={classNames(projectcss.all, sty.freeBox)}
          >
            <TopBar
              data-plasmic-name={"topBar"}
              data-plasmic-override={overrides.topBar}
              className={classNames("__wab_instance", sty.topBar)}
              userNameText={"Jones Ferdinand"}
            />

            <Stack__
              as={"div"}
              data-plasmic-name={"figmaPaste"}
              data-plasmic-override={overrides.figmaPaste}
              hasGap={true}
              className={classNames(projectcss.all, sty.figmaPaste)}
            >
              <div
                data-plasmic-name={"title"}
                data-plasmic-override={overrides.title}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.title
                )}
              >
                {"Contracts"}
              </div>
              <div
                data-plasmic-name={"searchVertStack"}
                data-plasmic-override={overrides.searchVertStack}
                className={classNames(projectcss.all, sty.searchVertStack)}
              />
            </Stack__>
            <div
              data-plasmic-name={"vertStack"}
              data-plasmic-override={overrides.vertStack}
              className={classNames(projectcss.all, sty.vertStack)}
            >
              <div
                data-plasmic-name={"figmaPaste3"}
                data-plasmic-override={overrides.figmaPaste3}
                className={classNames(projectcss.all, sty.figmaPaste3)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__vAytV
                  )}
                >
                  {"Title"}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__i6E36
                  )}
                >
                  {"Client"}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__kvZc
                  )}
                >
                  {"Status"}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__nhHeZ
                  )}
                >
                  {"Budget"}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__xFsnl
                  )}
                >
                  {"Date"}
                </div>
              </div>
              <Stack__
                as={"div"}
                data-plasmic-name={"contractCardsStack"}
                data-plasmic-override={overrides.contractCardsStack}
                hasGap={true}
                className={classNames(projectcss.all, sty.contractCardsStack)}
              >
                <ContractsListCard
                  className={classNames(
                    "__wab_instance",
                    sty.contractsListCard__etbj4
                  )}
                  client={"john"}
                  title={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___3Si27
                      )}
                    >
                      {"till"}
                    </div>
                  }
                />

                <ContractsListCard
                  className={classNames(
                    "__wab_instance",
                    sty.contractsListCard__nPq5H
                  )}
                />
              </Stack__>
              <div
                data-plasmic-name={"paginationStack"}
                data-plasmic-override={overrides.paginationStack}
                className={classNames(projectcss.all, sty.paginationStack)}
              >
                <div
                  data-plasmic-name={"prevButton"}
                  data-plasmic-override={overrides.prevButton}
                  className={classNames(projectcss.all, sty.prevButton)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__dt0Zw
                    )}
                  >
                    {"Previous"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"nextButton"}
                  data-plasmic-override={overrides.nextButton}
                  className={classNames(projectcss.all, sty.nextButton)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___1M24E
                    )}
                  >
                    {"Next"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "freeBox",
    "topBar",
    "figmaPaste",
    "title",
    "searchVertStack",
    "vertStack",
    "figmaPaste3",
    "contractCardsStack",
    "paginationStack",
    "prevButton",
    "nextButton"
  ],

  sidebar: ["sidebar"],
  freeBox: [
    "freeBox",
    "topBar",
    "figmaPaste",
    "title",
    "searchVertStack",
    "vertStack",
    "figmaPaste3",
    "contractCardsStack",
    "paginationStack",
    "prevButton",
    "nextButton"
  ],

  topBar: ["topBar"],
  figmaPaste: ["figmaPaste", "title", "searchVertStack"],
  title: ["title"],
  searchVertStack: ["searchVertStack"],
  vertStack: [
    "vertStack",
    "figmaPaste3",
    "contractCardsStack",
    "paginationStack",
    "prevButton",
    "nextButton"
  ],

  figmaPaste3: ["figmaPaste3"],
  contractCardsStack: ["contractCardsStack"],
  paginationStack: ["paginationStack", "prevButton", "nextButton"],
  prevButton: ["prevButton"],
  nextButton: ["nextButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicContractsList2__ArgProps,
          internalVariantPropNames: PlasmicContractsList2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicContractsList2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicContractsList2";
  } else {
    func.displayName = `PlasmicContractsList2.${nodeName}`;
  }
  return func;
}

export const PlasmicContractsList2 = Object.assign(
  // Top-level PlasmicContractsList2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    freeBox: makeNodeComponent("freeBox"),
    topBar: makeNodeComponent("topBar"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    title: makeNodeComponent("title"),
    searchVertStack: makeNodeComponent("searchVertStack"),
    vertStack: makeNodeComponent("vertStack"),
    figmaPaste3: makeNodeComponent("figmaPaste3"),
    contractCardsStack: makeNodeComponent("contractCardsStack"),
    paginationStack: makeNodeComponent("paginationStack"),
    prevButton: makeNodeComponent("prevButton"),
    nextButton: makeNodeComponent("nextButton"),
    // Metadata about props expected for PlasmicContractsList2
    internalVariantProps: PlasmicContractsList2__VariantProps,
    internalArgProps: PlasmicContractsList2__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicContractsList2;
/* prettier-ignore-end */
